import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { TENANT_ID } from 'global/constants';

import { getTenantId, withTenant } from 'utils/tenantUtil';

import './css/CardComponents.sass';

export const CardComponent = ({ cardClass, card }) => {
  const tenantId = getTenantId();
  const additionalStyle =
    tenantId === TENANT_ID.SHNG ? { fontWeight: '500' } : { fontWeight: '400' };

  const renderContent = () =>
    card.teaser.elementsList.map((element, index) => {
      if (element.tel) {
        return (
          <div key={index}>
            <i className="material-icons">chevron_right</i>
            <div>
              <a href={`tel:+49${element.tel}`}>{element.tel}</a>
            </div>
          </div>
        );
      }
      return (
        <div key={index} className="card-teaser-item">
          <i className="material-icons">chevron_right</i>
          <div style={additionalStyle}>
            <div>{element.name}</div>
          </div>
          {element.number >= 0 && <div className="card-teaser-number">{element.number}</div>}
        </div>
      );
    });

  return (
    <div className={cardClass} data-testid={withTenant('cardComponent')}>
      <div className="card-content-container">
        <div
          className={classNames(`teaser-title`, {
            'teaser-title__MTN': tenantId === TENANT_ID.MTN,
          })}
          style={additionalStyle}>
          <div>{card.title}</div>
          <div className="card-content-icon">{card.icon}</div>
        </div>

        <div className={`card-teaser-list ${tenantId}`}>{renderContent()}</div>
      </div>
    </div>
  );
};

CardComponent.propTypes = {
  cardClass: PropTypes.string.isRequired,
  card: PropTypes.object.isRequired,
};
